<script lang="ts">
      import { onMount } from 'svelte'
      import Gtag from "./Gtag.svelte"
      import { createAnalyticsContext } from './ts/Anatytics.svelte'
      import Sklik from './Sklik.svelte'
      import Pixel from './Pixel.svelte'



      onMount( () => {
        window._analytics = analytics
        analytics.loadUserPrefrences()
        analytics.checkConsent()
      })


      const analytics = createAnalyticsContext({key: "DF-CONSENT"})

      let { children = undefined } = $props() 

</script>

<Gtag></Gtag>
<Sklik></Sklik>
<Pixel></Pixel>
{@render children?.()}

<style lang="postcss">
</style>
